import { LogoutOutlined, RightOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { formatUserRole } from '@/constants/roles';
import { ROUTES } from '@/constants/routes';
import * as authApi from '@/services/api/auth';
import { useAuthStore } from '@/stores/auth.store';

export function LeaderMinePage() {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const clearSession = useAuthStore((state) => state.clearSession);

  if (!user) {
    return null;
  }

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // ignore
    } finally {
      clearSession();
      navigate(ROUTES.login, { replace: true });
      message.success('已退出登录');
    }
  };

  const initial = user.name.trim().charAt(0) || '用';

  return (
    <div>
      <div className="mobile-mine-header">
        <div className="mobile-mine-avatar">{initial}</div>
        <div>
          <div className="mobile-mine-name">{user.name}</div>
          <div className="mobile-mine-sub">{formatUserRole(user.role)}</div>
          <div className="mobile-mine-sub">{user.phone}</div>
        </div>
      </div>

      <div className="mobile-menu-list" style={{ marginBottom: 12 }}>
        <Link className="mobile-menu-item" to={ROUTES.mobile.leader.myReport}>
          <span>我的日报</span>
          <RightOutlined className="mobile-menu-item__arrow" />
        </Link>
        <Link className="mobile-menu-item" to={ROUTES.mobile.leader.history}>
          <span>历史日报</span>
          <RightOutlined className="mobile-menu-item__arrow" />
        </Link>
        <Link className="mobile-menu-item" to={ROUTES.mobile.leader.profile}>
          <span>个人信息</span>
          <RightOutlined className="mobile-menu-item__arrow" />
        </Link>
        <Link className="mobile-menu-item" to={ROUTES.mobile.leader.password}>
          <span>修改密码</span>
          <RightOutlined className="mobile-menu-item__arrow" />
        </Link>
      </div>

      <button
        type="button"
        className="mobile-menu-list mobile-btn mobile-btn--ghost mobile-btn--block"
        style={{ width: '100%', border: 'none', borderRadius: 8 }}
        onClick={() => void handleLogout()}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
          <LogoutOutlined />
          退出登录
        </span>
      </button>
    </div>
  );
}
